var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg100Change(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#474749"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5826 10.5826H13.5043V13.5043H10.5826V10.5826ZM9 9H10.5826H13.5043H15.087V10.5826V13.5043V15.087H13.5043H10.5826H9V13.5043V10.5826V9ZM10.5826 18.4957H13.5043V21.4174H10.5826V18.4957ZM9 16.913H10.5826H13.5043H15.087V18.4957V21.4174V23H13.5043H10.5826H9V21.4174V18.4957V16.913ZM21.4174 10.5826H18.4957V13.5043H21.4174V10.5826ZM18.4957 9H16.913V10.5826V13.5043V15.087H18.4957H21.4174H23V13.5043V10.5826V9H21.4174H18.4957ZM18.4957 18.4957H21.4174V21.4174H18.4957V18.4957ZM16.913 16.913H18.4957H21.4174H23V18.4957V21.4174V23H21.4174H18.4957H16.913V21.4174V18.4957V16.913Z",
    fill: "#E0E0E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg100Change);
export default __webpack_public_path__ + "static/media/100-change.c22a6be9a582e4ed353ad06ef2937c17.svg";
export { ForwardRef as ReactComponent };